import { Link2, LogOut } from "lucide-react";
import { api } from "../lib/api";
import type { Me } from "../lib/queries";

export function NoCompanies({ me }: Readonly<{ me: Me }>) {
    const logout = async () => {
        await api("/auth/logout", { method: "POST" });
        location.href = "/login";
    };
    return (
        <div className="grid min-h-full place-items-center p-4">
            <div className="card w-full max-w-md space-y-4 p-6 text-center">
                <h1 className="m-0 text-xl text-ink">No businesses yet</h1>
                <p className="m-0 text-muted">
                    Signed in as {me.user.email}. You're not part of any connected ServiceM8 business. If you run the ServiceM8
                    account, connect it below; otherwise ask your ServiceM8 admin to connect it.
                </p>
                <a href="/servicem8/connect?from=web" className="btn-primary w-full">
                    <Link2 className="size-4" /> Connect ServiceM8
                </a>
                <button type="button" className="btn-secondary w-full" onClick={() => void logout()}>
                    <LogOut className="size-4" /> Sign out
                </button>
            </div>
        </div>
    );
}
